import { Component, Input } from '@angular/core';
import { DatePipe } from '@angular/common';
import { SafeHtmlPipePipe } from '../../shared/pipes/safe-html.pipe';
import { ConvertLinkablePipe } from '@app/shared/pipes/convert-linkable.pipe';

@Component({
    selector: 'app-customer-message',
    templateUrl: './customer-message.component.html',
    styleUrls: ['./customer-message.component.scss'],
    standalone: true,
    imports: [DatePipe, SafeHtmlPipePipe, ConvertLinkablePipe]
})
export class CustomerMessageComponent {
  @Input() msg: any; // todo - type this out
}
